<template>
  <div class="about">
    <header-nav :linkId="activeNum"></header-nav>
    <div class="main">
    <el-row type="flex" justify="space-between" class="content">
				<el-col :xs="24" :sm="10" :md="10" :lg="8" :xl="8" class="txt lt">
          <div class="logo">
            <img src="../assets/company.png" alt="">
          </div>
        </el-col>
        <el-col :xs="24" :sm="13" :md="14" :lg="16" :xl="16"  class="rt">
          <h3 class="title">公司介绍</h3>
          <p class="desc">深圳市三丰创投有限公司成立于2017年，总部位于深圳。公司主要布局移动互联网软件研发、扫码开票助手、 聚合支付、区块链电子发票、微信公众号运营及创业投资等领域；专注于商家开票+支付场景化服务。</p>
          <p class="desc">公司创始人团队出自百度和赶集网，拥有多年互联网电子商务行业经验，聚集了来自百米，小牛资本，百度， 赶集网的精英，组成了专业的研发，运营和管理队伍。</p>
        </el-col>
			</el-row>
      <div class="info">
        <el-row class="row">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-for="item in infoList" :key="item.id">
            <div class="icon-box">
              <img class="icon" :class="'icon' + item.id" :src="item.icon" alt="">
            </div>
            <div class="item">
              <h6 class="tit">{{ item.title }}</h6>
              <p class="txt">{{ item.desc }}</p>
            </div>
          </el-col>
        </el-row>
        <!-- <ul class="info-mobile" v-else>
          <li :xs="24" :sm="24" :md="8" :lg="8" :xl="4" v-for="item in infoList" :key="item.id">
            <div class="icon-box">
              <img class="icon" :class="'icon' + item.id" :src="item.icon" alt="">
            </div>
            <div class="item">
              <h6 class="tit">{{ item.title }}</h6>
              <p class="txt">{{ item.desc }}</p>
            </div>
          </li>
        </ul> -->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
const icon1 = require('@/assets/svg/vision.svg')
const icon2 = require('@/assets/svg/mission.svg')
const icon3 = require('@/assets/svg/values.svg')
import headerNav from '../components/Header.vue'
import Footer from '../components/Footer.vue'
export default {
  name: 'Home',
  components: {
    headerNav,
    Footer
  },
  data() {
    return {
      activeNum: '3',
      infoList: [
        {
          id: '1',
          icon: icon1,
          title: '愿景',
          desc: '5年成为国内领先的金融科技公司，10年成为国内领先的商业智能公司。'
        }, {
          id: '2',
          icon: icon2,
          title: '使命',
          desc: '用科技赋能各个行业、每个客户，通过商业智能助力产业发展，做一家基业长青的公司。'
        }, {
          id: '3',
          icon: icon3,
          title: '价值观',
          desc: '持续为伙伴创造价值艰苦奋斗，改变命运向前一步，勇担责任'
        }
      ],
      isMobile: false
    }
  },
  mounted() {
    this.isMobile = this.UA().mobile
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.about {
  .main {
    max-width: 12rem;
    margin: 1rem auto 0;
    .content {
      .rt {
        margin-right: .7rem;
        &.el-col-sm-13 {
          margin-right: 0;
        }
      }
    }
    .logo {
      max-width: 3.6rem;
      max-height: 2.5rem;
      margin: auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      margin: .45rem 0 .42rem;
      font-size: .3rem;
      color: #333;
    }
    .desc {
      max-width: 6.66rem;
      font-size: .14rem;
      color: #333;
      margin-bottom: .06rem;
    }
    .info {
      max-width: 12rem;
      height: 2.67rem;
      background:rgba(248,248,248,1);
      box-sizing: border-box;
      padding: .6rem 1rem;
      margin-top: 1rem;
    }
    .row {
      display: flex;
      justify-content: space-between;
      .el-col {
        display: flex;
        margin: 0 auto;
        width: auto;
      }
      .item {
        max-width: 1.32rem;
        color: #333;
        .tit {
          margin-bottom: .16rem;
          font-size: .18rem;
        }
        .txt {
          font-size: .14rem;
        }
      }
      .icon-box {
        width: .8rem;
        height: .8rem;
        background:rgba(255,255,255,1);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: .2rem;
        .icon1 {
          width: .42rem;
          height: .42rem;
        }
        .icon2 {
          width: .5rem;
          height: .5rem;
        }
        .icon3 {
          width: .47rem;
          height: .47rem;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .about {
    .main {
      max-width: 100%;
      margin: 0 .2rem;
      .logo {
        margin: .5rem auto .4rem;
        max-width: 100%;
        max-height: 100%;
      }
      .content {
        flex-direction: column;
        .lt {
          width: 100%;
        }
        .title {
          font-size: .3rem;
          margin: 0 0 .1rem;
        }
        .desc {
          max-width: 100%;
          margin-bottom: .12rem;
          font-size: .24rem;
        }
      }
      .row {
        flex-direction: column;
        .el-col {
          margin: .3rem 0;
        }
      }
      .info {
        padding: .3rem .85rem;
        height: 100%;
        .icon-box {
          width: 1.7rem;
          height: 1.7rem;
          .icon1, .icon2,.icon3 {
            width: .6rem;
            height: .6rem;
          }
        }
        .item {
          max-width: 65%;
          .tit {
            font-size: .26rem;
          }
          .txt {
            font-size: .24rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AboutUs.vue